import React, { useRef, useState } from 'react';
import { Box, Button, Paper, Typography, useTheme } from '@mui/material';
import { useEventTracking } from '@services/statsig';

import { CreateRulePopover } from './CreateRulePopover';

interface AddRuleCardProps {
  /** Callback when user submits rule description from popover */
  onCreateRule: (description: string) => void;
}

export const AddRuleCard: React.FC<AddRuleCardProps> = ({ onCreateRule }) => {
  const theme = useTheme();
  const { jotauditDashboard } = useEventTracking();
  const [popoverOpen, setPopoverOpen] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const handleCreateRuleClick = () => {
    // Track add rule click
    jotauditDashboard.addRuleClicked({
      source: 'rules_tab',
    });
    setPopoverOpen(true);
  };

  const handlePopoverClose = () => {
    setPopoverOpen(false);
  };

  const handlePopoverSubmit = (description: string) => {
    onCreateRule(description);
  };

  return (
    <>
      <Paper
        elevation={0}
        sx={{
          p: 3,
          bgcolor: '#F8F9FB', // Light gray background from image
          border: `1px solid ${theme.palette.grey[100]}`,
          borderRadius: 3,
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <Box sx={{ mb: 3 }}>
          <Typography variant="h5" sx={{ fontWeight: 700 }}>
            Add New Rules
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Button
            ref={buttonRef}
            variant="contained"
            onClick={handleCreateRuleClick}
            sx={{
              bgcolor: '#2D336B',
              color: 'white',
              textTransform: 'none',
              borderRadius: '20px',
              px: 3,
              fontWeight: 600,
              '&:hover': {
                bgcolor: '#1E2248',
              },
            }}
          >
            Create New Rule
          </Button>
        </Box>
      </Paper>

      <CreateRulePopover
        open={popoverOpen}
        anchorEl={buttonRef.current}
        onClose={handlePopoverClose}
        onSubmit={handlePopoverSubmit}
      />
    </>
  );
};

